import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '75%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    right: 0,
    margin: 'auto',
    overflow: 'auto',
  },
  root: {
    padding: theme.spacing(3),
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    border: 0,
    padding: 0,
    fontSize: 30,
    backgroundColor: 'transparent',
  },
}));
const Header = (props) => {
  const { titulo, onClick } = props;
  const classes = useStyles();

  return (
    <Grid container justifyContent="space-between" style={{ marginBottom: 20 }}>
      <Grid item>
        <Typography component="h2" variant="h3">
          {titulo || "Titulo"}
        </Typography>
      </Grid>
      <Grid item>
        <button
          onClick={onClick}
          aria-label="Close"
          className={classes.close}
          type="button"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Grid>
    </Grid>
  );
};

Header.propTypes = {
  titulo: PropTypes.string,
};

export default Header;
